import React, { Component } from "react";
import { Route, Switch, Redirect } from "react-router";
import { blueGrey500, blueGrey700, redA700 } from "material-ui/styles/colors";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import getMuiTheme from "material-ui/styles/getMuiTheme";

import Login from "../login/Login";
import SendPassword from "../login/SendPassword";
import Statistics from "../statistics/Statistics";
import MerchantList from "../merchant/List";
import Merchant from "../merchant/Merchant";
import Partnership from "../partnership/Partnership";
import Sales from "../sales/Sales";
import Queries from "../queries/Queries";
import Error404 from "./Error404";
import Layout from "./Layout";
import Snackbar from "./Snackbar";
import Token from "../services/token";

const muiTheme = getMuiTheme({
  palette: {
    primary1Color: blueGrey500,
    primary2Color: blueGrey700,
    accent1Color: redA700
  }
});

export default class App extends Component {
  render() {
    return (
      <MuiThemeProvider muiTheme={muiTheme}>
        <div>
          <Switch>
            <Route path="/" exact component={Login} />
            <Route path="/login" component={Login} />
            <Route path="/mot-de-passe-oublie" component={SendPassword} />
            <Route render={this.authenticatedRoutes} />
          </Switch>
          <Snackbar className="snack" autoHideDuration={4000} />
        </div>
      </MuiThemeProvider>
    );
  }

  authenticatedRoutes(props) {
    return Token.read() ? (
      <Layout to={props.location.pathname}>
        <Switch>
          <Route exact path="/statistiques" component={Statistics} />
          <Route
            exact
            path="/configuration/marchands"
            component={MerchantList}
          />
          <Route
            path="/configuration/marchands/:merchantCode"
            component={Merchant}
          />
          <Route path="/configuration/partenariats/" component={Partnership} />
          <Route path="/ventes/" component={Sales} />
          <Route path="/requetes" component={Queries} />
          <Route path="*" component={Error404} />
        </Switch>
      </Layout>
    ) : (
      <Redirect to="/login" />
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/App.js